import React, { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

const ATTACHMENTS_BASE_URL = '/api/attachments'

const DownloadPage = () => {
  const [searchParams] = useSearchParams()

  const attachmentIds = searchParams.get('attachmentIds') ?? undefined
  const zippedFileName = searchParams.get('zippedFileName') ?? undefined
  const redirectPath = searchParams.get('redirectPath') ?? undefined

  const downloadLink = zippedFileName
    ? `${ATTACHMENTS_BASE_URL}/v3/files?humanIds=${attachmentIds}&zippedFileName=${zippedFileName}`
    : `${ATTACHMENTS_BASE_URL}/v3/${attachmentIds}/file`

  useEffect(() => {
    if (attachmentIds) {
      window.open(downloadLink, '_self')
    }
  }, [downloadLink, attachmentIds])

  return <Navigate to={redirectPath || '/'} />
}

export default DownloadPage
